import axios, { AxiosResponse } from 'axios';
import * as utils from './apiUtils';
import { AdminGroup2IndexResponse } from '@/models/apis/group2/adminGroup2Response';

export default {
  adminIndex(): Promise<AxiosResponse<AdminGroup2IndexResponse>> {
    return axios.get(utils.getApiUrl('/admin/groups2'));
  },
};
